<template>
  <div class="width-date-picker">
    <el-form
      label-position="top"
      :model="form"
      :rules="rules"
      ref="form"
      class="text-left modal-page"
    >
      <el-form-item
        label="ชื่อหัวข้อกระดานถาม - ตอบระหว่างเรียน (Discussion Forum)"
        prop="name"
      >
        <el-input v-model="form.name"></el-input>
      </el-form-item>

      <el-form-item
        label="ระยะเวลาในการเปิด-ปิดกระดานถาม - ตอบระหว่างเรียน (Discussion Forum)"
        prop="distanceDate"
        class="line-unset"
      >
        <el-date-picker
          v-model="form.distanceDate"
          type="daterange"
          range-separator="ถึง"
          start-placeholder=""
          end-placeholder=""
          class="show-in-desktop"
          :picker-options="{
            disabledDate(time) {
              return (
                time.getTime() < new Date(startDate).getTime() ||
                time.getTime() > new Date(endDate).getTime()
              );
            },
          }"
        >
        </el-date-picker>
        <div class="flex-display js-between show-in-desktop">
          <span class="color-gray line-initial text-font-12">เวลา 0.00 น.</span>
          <span class="color-gray line-initial text-font-12">เวลา 23.59 น.</span>
        </div>

        <el-date-picker
          v-model="form.distanceDate[0]"
          type="date"
          format="d MMMM yyyy"
          class="show-in-mobile width-100"
          :picker-options="{
            disabledDate(time) {
              return time.getTime() > new Date(form.distanceDate[1]).getTime() ||
              time.getTime() < new Date(startDate).getTime() ||
              time.getTime() > new Date(endDate).getTime()
            },
          }"
        >
        </el-date-picker>
        <span class="color-gray line-initial text-font-12 show-in-mobile">เวลา 0.00 น.</span>

        <el-date-picker
          v-model="form.distanceDate[1]"
          type="date"
          format="d MMMM yyyy"
          class="show-in-mobile mg-t-4 width-100"
          :picker-options="{
            disabledDate(time) {
              return time.getTime() < new Date(form.distanceDate[0]).getTime() ||
              time.getTime() < new Date(startDate).getTime() ||
              time.getTime() > new Date(endDate).getTime()
            },
          }"
        >
        </el-date-picker>
        <span class="color-gray line-initial text-font-12 show-in-mobile">เวลา 23.59 น.</span>
      </el-form-item>
      <el-form-item
        label="รายละเอียดกระดานถาม - ตอบระหว่างเรียน (Discussion Forum)"
        prop="description"
      >
        <yimo-vue-editor
          v-model="form.description"
          @input="checkValid('description')"
        ></yimo-vue-editor>
      </el-form-item>
    </el-form>
    <div class="text-center pd-y-3">
      <el-button
        @click="edit?updateDiscussionForum():createDiscussionForum()"
        type="primary"
        round
        class="pd-x-1"
        >{{edit?'แก้ไขกระดานคำถาม':'เพิ่มกระดานคำถาม'}}</el-button
      >
    </div>
  </div>
</template>

<script>
import { nbspRem } from "@/service/editor";

export default {
  props:{
    descussion:{
      type:Object,
      default(){
        return null
      }
    },
    edit:{
      type:Boolean,
      default(){
        return false
      }
    },
    startDate: {
      type: String,
      default() {
        return "";
      },
    },
    endDate: {
      type: String,
      default() {
        return "";
      },
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    descussion(){
      this.setDescussion()
    }
  },
  data() {
    return {
      form: {
        name: "",
        distanceDate: [],
        description: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "กรุณากรอกชื่อหัวข้อ",
            trigger: "blur",
          },
        ],
        distanceDate: [
          {
            required: true,
            message: "กรุณาเลือกระยะเวลาในการเปิด-ปิด",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {
    this.setDescussion()
  },
  methods: {
    setDescussion(){
      if (this.edit) {
        this.form = {
          name: this.descussion.title,
          distanceDate:typeof this.descussion.durationTime != 'undefined' && this.descussion.durationTime.open? [
            this.descussion.durationTime.open,
            this.descussion.durationTime.close,
          ]:[],
          description: this.descussion.description
        } 
      } else {
        this.form = {
          name: '',
          distanceDate: [],
          description: ''
        }
      }
    },
    checkValid(field) {
      if (this.$options.filters.striphtml(this.form.description) == "") {
        this.form.description = "";
      }
      this.$refs["form"].validateField(field);
    },
    createDiscussionForum() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("createDiscussionForum", this.form);
        }
      });
    },
    updateDiscussionForum() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let obj = {
            id:this.descussion._id,
            name: this.form.name,
            distanceDate: this.form.distanceDate,
            description: this.form.description
          }

          this.$emit("updateDiscussionForum", obj);
        }
      });
    },
  },
};
</script>